/**
 * Columns an SFTP delivery's `field_filter` may name — the GMC supplementary
 * columns (backend `tsv_generator.py SUPPLEMENTARY_COLUMNS`). `id` is always
 * written first, so it isn't offered. A checklist rather than free text because
 * an unknown name fails the whole run with `UnknownFieldError`; only columns
 * present in the enrichment table are written, so an unchecked list = all.
 */
export const SFTP_DELIVERY_COLUMNS: readonly string[] = [
  'title',
  'structured_title',
  'description',
  'structured_description',
  'google_product_category',
  'product_type',
  'product_highlight',
  'product_detail',
  'features',
  'product_qa',
  'specs',
  'color',
  'material',
  'pattern',
  'size_type',
  'style_and_aesthetic',
  'care_instruction',
  'sale_price',
  'promotion_id',
  'certification',
  'product_height',
  'product_width',
  'product_length',
  'product_weight',
];

/**
 * Whether the connector behind a connection can receive a pushed feed file —
 * `resources.feed_file` includes `"push"` on backends that ship SFTP delivery.
 * Reads defensively because the capability matrix is an untyped JSON map.
 */
export function supportsFeedFilePush(capabilities: Record<string, unknown> | null | undefined) {
  const resources = capabilities?.resources;
  if (!resources || typeof resources !== 'object') return false;
  const feedFile = (resources as Record<string, unknown>).feed_file;
  return Array.isArray(feedFile) && feedFile.includes('push');
}
